import React, { useState, useContext } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import BnplContactUs from './BnplContactUs';
import BnplFooter from './BnplFooter';
import BnplLoading from './BnplLoading';
import BnplModal from './BnplModal';
import BnplPrivacyPolicy from './BnplPrivacy';
import BnplTerms from './BnplTerms';

import Back from '../../assets/images/back.svg';
import Close from '../../assets/images/close.svg';
import TenantConfig from '../../config';
import { UserContext } from '../../context/UserContext';
import { cleanUpSessionData } from '../../helpers/applicationHelp';
import Header from '../common/Header';

export default function BnplFormContainer({
  children,
  onBack,
  isDesktop = false,
  hideForm = false,
  hideBack,
  showControls = true,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const { setProfile, width, authHeaderBeakpoint, loading } = useContext(UserContext);
  const [activeModal, setActiveModal] = useState();
  const [openModal, setOpenModal] = useState(false);
  const goBack = () => navigate(-1);

  const handleClose = () => {
    setProfile({});
    cleanUpSessionData();
    navigate('/auth/sign-in');
  };

  const renderDesktopHeader = isDesktop && width >= authHeaderBeakpoint;

  return (
    <div className="landing-page">
      {renderDesktopHeader && <Header breakpoint={authHeaderBeakpoint} />}
      <div
        className={
          location.pathname == '/landing'
            ? 'bnpl-form__landing'
            : hideForm || loading
            ? 'bnpl-form__container hide-form'
            : 'bnpl-form__container'
        }
      >
        {!renderDesktopHeader && (
          <>
            {showControls ? (
              <div className="bnpl-form__container__controls">
                <button onClick={onBack ?? goBack} className="bnpl-form__container__controls__back">
                  <img src={Back} alt="back" className={hideBack ? 'hide' : ''} />
                </button>
                <img
                  className="bnpl-form__container__controls__logo"
                  src={TenantConfig.headerLogo}
                  alt="logo"
                />
                <button onClick={handleClose} className="bnpl-form__container__controls__close">
                  <img src={Close} alt="close" className={loading ? 'hide' : ''} />
                </button>
              </div>
            ) : (
              <div className="bnpl-form__container__nocontrols">
                <img
                  className="bnpl-form__container__controls__logo"
                  src={TenantConfig.headerLogo}
                  alt="logo"
                />
              </div>
            )}
          </>
        )}
        {children}
        <BnplFooter setActiveModal={setActiveModal} setOpenModal={setOpenModal} />
      </div>
      <BnplModal
        openModal={openModal}
        closeModal={() => setOpenModal(false)}
        setActiveModal={setActiveModal}
        setOpenModal={setOpenModal}
      >
        {activeModal === 'terms' && <BnplTerms className="bnpl-form" />}
        {activeModal === 'privacy' && <BnplPrivacyPolicy className="bnpl-form" />}
        {activeModal === 'contact' && <BnplContactUs className="bnpl-form" />}
      </BnplModal>
      {loading && (
        <div className={'collect-js-loading-wrapper'}>
          <BnplLoading className={'bnpl-form'} isAuth />
        </div>
      )}
    </div>
  );
}
